export enum EncounterAmendmentReason {
  ProviderCorrectionOfInformation = "provider-correction-of-information",
  ClientRequestedChange = "client-requested-change",
  Other = "other",
}

export const EncounterAmendmentReasonLabels = {
  [EncounterAmendmentReason.ProviderCorrectionOfInformation]: "Provider Correction of Information",
  [EncounterAmendmentReason.ClientRequestedChange]: "Client Requested Change",
  [EncounterAmendmentReason.Other]: "Other",
};
